<h5>Add Consult Note Reference from Client EHR</h5>

<app-ehr-consult-note-reference-form
  (saved)="onSave($event)"
  (canceled)="onCancel()"
  [errors]="ehrConsultNoteReferenceErrors" />
